module.exports = __webpack_public_path__ + "static/logo-152b297cf4a267b43df63939a9e5b73a.png";